import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import './IOSGallery.css';

function IOSGallery() {
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const mockups = [
        {
            id: 'dashboard',
            src: `${process.env.PUBLIC_URL}/iosDashboardwTissue.png`,
            title: 'Analytics Dashboard',
            description: 'Comprehensive dive analytics with period comparisons, charts, and personal records tracking'
        },
        {
            id: 'dive-locations',
            src: `${process.env.PUBLIC_URL}/iosDiveLocations.png`,
            title: 'Dive Locations',
            description: 'Interactive map view of all your dive sites with location details'
        },
        {
            id: 'dive-history',
            src: `${process.env.PUBLIC_URL}/iosDiveHistory.png`,
            title: 'Dive History',
            description: 'Complete dive logbook with searchable entries and timeline view'
        },
        {
            id: 'dive-details',
            src: `${process.env.PUBLIC_URL}/iosDiveDetails.png`,
            title: 'Dive Details',
            description: 'Detailed dive analysis with interactive charts and sensor data visualization'
        },
        {
            id: 'dive-details-2',
            src: `${process.env.PUBLIC_URL}/iosDiveDetails2.png`,
            title: 'Advanced Details',
            description: 'Extended dive information with GPS tracking and environmental data'
        },
        {
            id: 'dive-details-ascent',
            src: `${process.env.PUBLIC_URL}/iosDiveDetailsAscent.png`,
            title: 'Ascent Profile',
            description: 'Detailed ascent analysis with safety stop monitoring and decompression data'
        },
        {
            id: 'dive-details-temp',
            src: `${process.env.PUBLIC_URL}/iosDiveDetailsTemp.png`,
            title: 'Temperature Analysis',
            description: 'Water temperature profiles and environmental condition tracking'
        },
        {
            id: 'dive-planning',
            src: `${process.env.PUBLIC_URL}/iosDivePlanning.png`,
            title: 'Dive Planning',
            description: 'Comprehensive planning tools with gas calculations and safety parameters'
        }
    ];

    const handleImageClick = (mockup) => {
        setSelectedImage(mockup);
        setShowModal(true);
    };

      return (
    <>
      <section id="ios-gallery" className="ios-gallery-section">
        <Container>
          <div className="ios-gallery-header" data-aos="fade-up">
            <h2 className="ios-gallery-title">iPhone Interface</h2>
            <p className="ios-gallery-subtitle">
              Explore the beautiful and intuitive iOS companion app interface
            </p>
          </div>

          <Row className="ios-gallery-grid g-4">
            {mockups.map((mockup, index) => (
              <Col lg={3} md={4} sm={6} key={mockup.id} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="mockup-card" onClick={() => handleImageClick(mockup)}>
                  <div className="mockup-image-container">
                    <img
                      src={mockup.src}
                      alt={mockup.title}
                      className="mockup-gallery-image"
                      loading="lazy"
                    />
                    <div className="mockup-overlay">
                      <div className="mockup-overlay-content">
                        <i className="fas fa-search-plus mockup-overlay-icon"></i>
                        <span className="mockup-overlay-text">View Details</span>
                      </div>
                    </div>
                  </div>
                  <div className="mockup-info">
                    <h5 className="mockup-title">{mockup.title}</h5>
                    <p className="mockup-description">{mockup.description}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* <div className="mt-5" data-aos="fade-up">
            <div className="gallery-cta">
              <h4 className="gallery-cta-title">
                Experience ZDIVE on iOS
              </h4>
              <p className="gallery-cta-description">
                Beautiful, intuitive, and powerful dive analytics in your pocket
              </p>
              <a 
                href="#download" 
                className="gallery-cta-button"
              >
                <i className="fab fa-apple gallery-cta-button-icon"></i>
                Download for iOS
              </a>
            </div>
          </div> */}
        </Container>
      </section>

            {/* Modal for enlarged view */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        className="mockup-modal"
      >
        <Modal.Header closeButton className="mockup-modal-header">
          <Modal.Title>{selectedImage?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mockup-modal-body">
          {selectedImage && (
            <>
              <img 
                src={selectedImage.src} 
                alt={selectedImage.title}
                className="mockup-modal-image"
              />
              <div className="mockup-modal-description-container">
                <p className="mockup-modal-description">
                  {selectedImage.description}
                </p>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default IOSGallery;
